import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { empty, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApplicationConfig } from '../config/config';
import { UrlUtil } from '../config/urlutil';
import { CountryLanguageService } from '../services/country_Language/country_Language.service';
import { CountryLanguageHelper } from './country-language-helper';

@Injectable({
  providedIn: 'root'
})
export class CountryLanguageResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private countryLanguageService: CountryLanguageService,
    private countryLanguageHelper: CountryLanguageHelper,
    private urlUtils: UrlUtil,
    private applicationConfig: ApplicationConfig
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    let countrycode = route.queryParams['loc'];
    let languagecode = route.queryParams['lang'];
    if (!countrycode && !languagecode) {
      countrycode = route.params['countrycode'];
      languagecode = route.params['languagecode'];
    }
    if (countrycode && languagecode) {
      this.countryLanguageService
        .countryLanguageDataFromAPI()
        .subscribe((countryLanguageData) => {
          if (countryLanguageData) {
            this.countryLanguageHelper.setData(countryLanguageData);
            const country =
              this.countryLanguageHelper.getCountryForCountryCode(countrycode);
            const language =
              this.countryLanguageHelper.getLangaugeForLanguageCode(
                countrycode,
                languagecode
              );
            if (country) {
              if (country.isRegion) {
                const countrycodepref =
                  this.countryLanguageHelper.getCountryCodeFromPrefCookie();
                if (countrycodepref) {
                  const countryForPref =
                    this.countryLanguageHelper.getCountryForCountryCode(
                      countrycodepref
                    );
                  if (
                    countryForPref === undefined ||
                    countryForPref === null ||
                    countryForPref.urlcc !== countrycode
                  ) {
                    this.countryLanguageHelper.setPrefCookie(
                      languagecode + '-' + countrycode
                    );
                    this.countryLanguageHelper.setPreferedLanguages(
                      languagecode + '-' + countrycode
                    );
                    this.countryLanguageHelper.setShowConfirmationModal(false);
                  }
                } else {
                  this.countryLanguageHelper.setPrefCookie(
                    languagecode + '-' + countrycode
                  );
                  this.countryLanguageHelper.setPreferedLanguages(
                    languagecode + '-' + countrycode
                  );
                  this.countryLanguageHelper.setShowConfirmationModal(false);
                }
              } else {
                if (language) {
                  if (
                    this.countryLanguageHelper.isDomainCorrectForLanguageCode(
                      languagecode
                    )
                  ) {
                    const countrycodepref =
                      this.countryLanguageHelper.getCountryCodeFromPrefCookie();
                    if (
                      countrycodepref === undefined ||
                      countrycodepref === null ||
                      countrycode !== countrycodepref.toLowerCase()
                    ) {
                      this.countryLanguageHelper.setShowConfirmationModal(
                        false
                      );
                    }
                    this.countryLanguageHelper.setPrefCookie(
                      languagecode + '-' + countrycode
                    );
                    this.countryLanguageHelper.setPreferedLanguages(
                      languagecode + '-' + countrycode
                    );
                  } else {
                    // Redirect to error page
                    window.location.href = `${
                      this.urlUtils.hostUrl
                    }${this.applicationConfig.get('APP_404_PAGE')}`;
                  }
                } else {
                  // Redirect to error page
                  window.location.href = `${
                    this.urlUtils.hostUrl
                  }${this.applicationConfig.get('APP_404_PAGE')}`;
                }
              }
            } else {
              window.location.href = `${
                this.urlUtils.hostUrl
              }${this.applicationConfig.get('APP_404_PAGE')}`;
            }
          } else {
            // this.router.navigate(['/']);
          }
        });
      return this.countryLanguageService.countryLanguageDataFromAPI().pipe(
        catchError((error) => {
          // this.router.navigate(['/']);
          return empty();
        })
      );
    }
  }
}
